import { useNotifyStore, useUserStore } from '~/store'

// À placer après auth : réserve la page au rôle admin
export default defineNuxtRouteMiddleware(async () => { // (to, from)
    const userStore = useUserStore()
    if (!userStore.currentUser?.k) {
        await userStore.fetchUser()
    }

    if (userStore.currentUser?.role !== 'admin') {
        // Utilisateur non connecté : auth l'a déjà signalé et le renvoie vers la connexion
        if (userStore.currentUser?.k) {
            useNotifyStore().showMessage({
                title: 'Accès refusé',
                text: 'Cette page est réservée aux administrateurs.',
                color: 'error',
                icon: 'mdi-alert-circle',
                timer: 5,
            })
        }
        return navigateTo('/')
    }
})
